import { BlotterPreferencePayload } from 'apiConnector/blotters/blotterPreferenceStatePersistance';
import { BaseRowData, Operation } from 'apiConnector/secondary-market/batch/base';
import {
  DeleteRequest,
  ModifyRequest,
  OperationRequest,
  OperationResponse,
  OrderType,
  ReloadResponse,
  ResetRequest,
  SearchRequest,
  SearchResponse,
} from 'apiConnector/secondary-market/batch/model';
import { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import { ignoreElements, map } from 'rxjs';
import { IHttpBody, IHttpClient } from 'utils/http/httpClient.model';

export function secondaryMarketBatchApiConnector(httpClient: IHttpClient) {
  const postOperation = <TPayloadResponse, TPayloadRequest extends IHttpBody>(
    orderType: OrderType,
    operation: string,
    body: TPayloadRequest,
  ) =>
    httpClient
      .postJSON<TPayloadResponse>({
        url: `api/v1/secondary-market/${orderType}/operations/${operation}`,
        body,
        tryParseErrorPayload: true,
        targetHost: 'SpBridge',
      })
      .pipe(map(({ payload }) => payload));

  return {
    saveState(orderType: OrderType, data: IBlotterPreferenceState) {
      const body: BlotterPreferencePayload = { version: 2, data };
      return httpClient
        .post({
          url: `api/v1/secondary-market/${orderType}/preference-state`,
          body,
        })
        .pipe(ignoreElements());
    },
    operation(orderType: OrderType, operationType: Operation, request: OperationRequest<BaseRowData>) {
      return postOperation<OperationResponse, OperationRequest<BaseRowData>>(orderType, operationType, request);
    },
    reset(orderType: OrderType, resetRequest: ResetRequest) {
      return postOperation<SearchResponse, ResetRequest>(orderType, 'reset', resetRequest);
    },
    search(orderType: OrderType, searchRequest: SearchRequest) {
      return httpClient
        .postJSON<SearchResponse>({
          url: `api/v1/secondary-market/${orderType}/products`,
          body: searchRequest,
          tryParseErrorPayload: true,
          targetHost: 'SpBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    modify(orderType: OrderType, request: ModifyRequest<BaseRowData>) {
      return httpClient
        .putJSON<SearchResponse>({
          url: `api/v1/secondary-market/${orderType}/forms`,
          body: request,
          tryParseErrorPayload: true,
          targetHost: 'SpBridge',
        })
        .pipe(map(({ payload }) => payload));
    },

    delete(orderType: OrderType, request: DeleteRequest) {
      return httpClient
        .deleteJSON({
          url: `api/v1/secondary-market/${orderType}/forms`,
          body: request,
          tryParseErrorPayload: true,
          targetHost: 'SpBridge',
        })
        .pipe(map(() => null));
    },
    reload(orderType: OrderType) {
      return httpClient
        .getJSON<ReloadResponse>({
          url: `api/v1/secondary-market/${orderType}/forms`,
          tryParseErrorPayload: true,
          targetHost: 'SpBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
